import React from 'react';
import {
    Badge
} from 'react-bootstrap';
import CONSTANTS from '../constants';
import ScrollContainer from "react-indiana-drag-scroll";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FiltersBadges({filters, menuDisabled, onChange}) {
    let badges = [];

    for (let tax of CONSTANTS.TAXONOMIAS_FILTROS) {
        if (filters.hasOwnProperty(tax.slug) && filters[tax.slug].length > 0) {
            for (let filter of filters[tax.slug]) {
                badges.push({
                    taxSlug: tax.slug,
                    slug: filter.slug,
                    label: filter.label
                })
            }
        }
    }

    const tipoGroup = filters.tipoGroup.filter(tipo => (tipo.active));
    if (tipoGroup.length < 4) {
        badges.push({
            slug: 'tipoGroup',
            label: 'Tipos: ' + tipoGroup.map(tipo => (
                CONSTANTS.TIPOS_DE_FICHA.filter(constantTipo => (constantTipo.id === tipo.id))[0].plural
            )).join(', ')
        })
    }

    return (
        <ScrollContainer
            className="filtersBadges"
            draggingClassName="filtersBadgesDragging"
        >
            {badges.map(badge => (
                <Badge
                    key={`filtersBadge_${badge.slug}`}
                    pill
                    bg="resultados"
                    className="me-2"
                >
                    {badge.label}
                    {!menuDisabled &&
                        <FontAwesomeIcon
                            icon={"times-circle"}
                            className="filtersBadgesDraggingClose"
                            onClick={(e) => {
                                if (badge.slug === 'tipoGroup') {
                                    let tipoGroup = CONSTANTS.TIPOS_DE_FICHA;
                                    for (let i of CONSTANTS.TIPOS_DE_FICHA.keys()) {
                                        tipoGroup[i].active = true;
                                    }
                                    onChange({
                                        tipoGroup: tipoGroup
                                    });
                                    return;
                                }

                                onChange({
                                    [badge.taxSlug]: filters[badge.taxSlug].filter(filter => (filter.slug !== badge.slug))
                                });
                            }}
                        />
                    }
                </Badge>
            ))}
        </ScrollContainer>
    );
}
